export const MEMBERS_MENU_ITEMS_STORAGE_KEY = 'members-menu-initial-items';
export const LOGIN_DROPDOWN_MENU_ITEMS_STORAGE_KEY =
  'login-dropdown-menu-initial-items';
